module.exports = __webpack_public_path__ + "img/skin-diagnostic-result-en.eaee5f5c.jpg";